<div class="modal-header">
    <span>{{ modalHeader }}</span>
    <button
        type="button"
        class="close"
        aria-label="Close"
        (click)="close()"
    >
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    {{ modalBody }}
    <br><br>
    <div class="row col-md-10 input-group">
        <formly-form
            [model]="model"
            [fields]="fields"
            [form]="form"
        >
        </formly-form>
       <!-- <input
            readonly="readonly"
            (click)="d2.toggle()"
            class="form-control"
            autocomplete="off"
            placeholder="dd/mm/yyyy"
            [(ngModel)]="date"
            [minDate]="minDate"
            [readonly]="true"
            [minDate]="minDate"
            [maxDate]="maxDate"
            ngbDatepicker
            #d2="ngbDatepicker"
            #datePicker
            (blur)="date = datePicker.value"
        >
        <button
            class="input-group-addon input-right-icon"
            (click)="d2.toggle();"
            type="button"
        >
            <i class="fa fa-calendar"></i>
        </button>-->
    </div>
    <small>Utilizza il pulsante del calendario per modificare la data</small>
</div>
<div class="modal-footer">
    <button
        nbButton
        [disabled]="!date || !date.year"
        (click)="closeModal(model.date)"
    >Conferma</button>
</div>
